module.exports = __webpack_public_path__ + "media/images/static/top/urban/left_photo-ae8abeafb7e4496f6cd3e413b633ffe6.png";